export const PLAN_TYPES = {
    FREE: 'free',
    BASIC: 'basic',
    PREMIUM: 'premium',
} as const;

export const MERCHANT_PLAN_NOTIFICATION_MESSAGES = {
    FETCH_SUCCESS: 'Plan information loaded successfully',
    FETCH_ERROR: 'Failed to load plan information',
    UPGRADE_SUCCESS: 'Plan upgraded successfully',
    UPGRADE_ERROR: 'Failed to upgrade plan',
} as const;

export const PLAN_FEATURES = {
    FREE: [
        '2 active coupons',
        'Standard listing',
        'Basic redemption controls',
        'Views-only analytics',
        'Email support (3-5 days)',
    ],
    BASIC: [
        '5 active coupons',
        'Priority listing (5 coupons visible)',
        '"Verified Partner" badge',
        'Redemption tracking & conversion rates',
        'Advanced redemption controls',
        'Email support (24-48 hours)',
        'Add Events/Surveys (+$49/mo)',
    ],
    PREMIUM: [
        '10 active coupons',
        'Featured placement (top of list)',
        '"Premium Partner" badge',
        'Full analytics & insights',
        'Geographic heatmap access',
        'Unlimited redemption controls',
        'Phone & email support (within 24 hrs)',
        'Add Events/Surveys (+$49/mo)',
    ],
} as const;

export const PLAN_PRICING = {
    FREE: { monthly: 0, annual: 0 },
    BASIC: { monthly: 30, annual: 300 }, // $30/mo = $360/year, save $60/year
    PREMIUM: { monthly: 100, annual: 1000 }, // $100/mo = $1200/year, save $200/year
} as const;
